export function safeInternalPath(path, fallback = '/') {
    if (!path || typeof path !== 'string') {
        return fallback;
    }

    const trimmed = path.trim();

    if (!trimmed.startsWith('/') || trimmed.startsWith('//')) {
        return fallback;
    }

    if (trimmed.includes('://') || trimmed.includes('\\')) {
        return fallback;
    }

    return trimmed;
}
